import { useState } from 'react';



const CaseConverter = () => {
  const [text, setText] = useState('');
  const [formatting, setFormatting] = useState({
    isBold: false,
    isItalic: false,
    isStrikethrough: false,
  });



  const handleTextChange = (e) => {
    setText(e.target.value);
  };

  const toggleCase = () => {
    const toggledText = text
      .split('')
      .map((char) =>
        char === char.toUpperCase() ? char.toLowerCase() : char.toUpperCase()
      )
      .join('');
    setText(toggledText);
  };

  const [copyButtonLabel, setCopyButtonLabel] = useState('Copy Text'); // State for button label

  const copyToClipboard = () => {
    navigator.clipboard.writeText(text);
    setCopyButtonLabel('Copied!'); // Update button label to "Copied!"
    setTimeout(() => setCopyButtonLabel('Copy Text'), 1500); // Revert back to "Copy Number" after 1.5 seconds
  };

  const toggleFormat = (format) => {
    setFormatting((prev) => ({
      ...prev,
      [format]: !prev[format],
    }));
  };

  const getTextStyle = () => {
    return {
      fontWeight: formatting.isBold ? 'bold' : 'normal',
      fontStyle: formatting.isItalic ? 'italic' : 'normal',
      textDecoration: formatting.isStrikethrough ? 'line-through' : 'none',
    };
  };


     // Function to calculate text statistics
     const calculateTextStats = (text) => {
      const totalCharacters = text.length;
      const totalCharactersWithoutSpace = text.replace(/\s+/g, '').length;
      const totalWords = text.trim() === '' ? 0 : text.trim().split(/\s+/).length;
      const totalParagraphs = text.split(/\n+/).filter(Boolean).length;
      const totalSentences = text.split(/[.!?]+/).filter(Boolean).length;
  
      return {
        totalCharacters,
        totalCharactersWithoutSpace,
        totalWords,
        totalParagraphs,
        totalSentences,
      };
    };
  
      // Calculate stats dynamically based on current binary value
  const stats = calculateTextStats(text);

  return (
    <div className="container mt-5 p-4 bg-white rounded shadow-md max-w-lg mx-auto">
      {/* Text Area */}
      <textarea
        className="w-full p-2 border rounded mb-4"
        value={text}
        onChange={handleTextChange}
        rows={8}
        style={getTextStyle()} // Apply the styles dynamically
        placeholder="Enter your text here..."
      />

      {/* Action Buttons */}
      <div className="d-flex align-items-center mb-3">
        <button className="btn btn-primary" onClick={toggleCase}>
        Case Inverse
        </button>
        
        <button className="btn btn-primary" onClick={copyToClipboard}>
        {copyButtonLabel}
        </button>
        <button
          className={`btn ${formatting.isBold ? 'btn-primary' : 'btn-outline-secondary'}`}
          onClick={() => toggleFormat('isBold')}
        >
         Bold
        </button>
        <button
          className={`btn ${formatting.isItalic ? 'btn-primary' : 'btn-outline-secondary'}`}
          onClick={() => toggleFormat('isItalic')}
        >
       Italic
        </button>
        
        <button
          className={`btn ${formatting.isStrikethrough ? 'btn-primary' : 'btn-outline-secondary'}`}
          onClick={() => toggleFormat('isStrikethrough')}
        >
          Strike Through
        </button>
      </div>


      <div className="mt-3 text-muted">
            <p>
              Total Characters with Space: {stats.totalCharacters} | Total Characters without Space: {stats.totalCharactersWithoutSpace} | Total Words: {stats.totalWords}</p>
            <p>
               Total Paragraphs: {stats.totalParagraphs} | Total Sentences: {stats.totalSentences}
            </p>
          </div>
    </div>
  );
};

export default CaseConverter;
